import globalTheme, { muiTheme } from '../../global'

const Form = {
	MuiFormLabel: {
		styleOverrides: {
			asterisk: {
				marginLeft: '1px',
				display: 'inline-block',
			},
			root: {
				color: globalTheme.palette.grey.main,
				fontSize: muiTheme.typography.pxToRem(12),
				marginBottom: '7px',
				letterSpacing: '0.2px',
				position: 'relative',
				transform: 'none',
				lineHeight: globalTheme.spacing(2),
				textAlign: 'left',
				'&.Mui-disabled': {
					color: globalTheme.palette.grey.light,
				},
				'&.Mui-focused': {
					color: globalTheme.palette.grey.main,
				},
				'&.Mui-error': {
					color: globalTheme.palette.error.main,
				},
			},
		},
	},
	MuiFormControlLabel: {
		styleOverrides: {
			root: {
				marginLeft: 0,
				marginTop: 9,
				marginBottom: 9,
				alignItems: 'flex-start',
			},
			label: {
				color: globalTheme.palette.primary.main,
				'&.Mui-disabled': {
					color: globalTheme.palette.grey.light,
				},
			},
		},
	},
	MuiFormHelperText: {
		styleOverrides: {
			root: {
				fontSize: globalTheme.typography.caption.fontSize,
				color: globalTheme.palette.grey.main,
				marginLeft: 0,
				marginRight: 0,
				marginTop: globalTheme.spacing(1),
				marginBottom: globalTheme.spacing(1),
			},
		},
	},
}

export default Form
